import { useCallback, useState } from 'react'

export type SnackbarPayload = {
  message: string
  variant: 'success' | 'error'
}

type SnackbarProps = {
  message: string | null
  variant: 'success' | 'error'
  onClose: () => void
}

export const useSnackbar = () => {
  const [state, setState] = useState<SnackbarPayload | null>(null)

  const notify = useCallback((payload: SnackbarPayload) => {
    setState(payload)
  }, [])

  const onClose = useCallback(() => setState(null), [])

  const snackbar: SnackbarProps = {
    message: state?.message ?? null,
    variant: state?.variant ?? 'success',
    onClose,
  }

  return { snackbar, notify }
}
